import { FC } from 'react';

import {
  EmptyState,
  EmptyStateImageVariant,
  EmptyStateVariant,
} from '../../../../components/empty-state/index';
import { useLocale } from '../../../../hooks/index';
import { StringKey } from '../../../../lang/index';

/**
 * The Activity screens' empty state: the shared card in the module's blue, with the magic wand.
 * The design wraps the hint at 226px, which is narrower than the shared card's own measure.
 */
export const ActivityEmptyState: FC<{ description: StringKey; title: StringKey }> = ({
  description,
  title,
}) => {
  const { messagesLocale } = useLocale();

  return (
    // The design hangs the card 72px under the tabs rather than centring it in the page, and lets
    // the circle's white ring overflow its 112px box instead of adding to the card's height. The
    // padding is the design's 80 by 32 less the border, which Figma keeps inside the box.
    <div className="flex w-full justify-center pt-[72px] [&>div>div:first-child]:-m-3 [&>div]:my-0">
      <EmptyState
        colorScheme={EmptyStateVariant.CUSTOM}
        description={<span className="block max-w-[226px]">{messagesLocale[description]}</span>}
        imageVariant={EmptyStateImageVariant.MAGIC_WAND}
        scheme={{
          borderClassName:
            'max-w-[386px] border border-[rgba(180,209,254,0.5)] bg-[radial-gradient(50%_50%_at_50%_50%,#ECEBFF_0%,#FFFFFF_100%)] px-[79px] py-[31px]',
          centralCircle: {
            bgGradient: { from: 'rgba(75, 191, 254, 0.13)', to: 'rgba(3, 32, 220, 0.13)' },
            border: 'rgba(3, 151, 220, 0.13)',
          },
          titleGradient: 'linear-gradient(166.04deg, #475467 29.58%, #101828 84.27%)',
        }}
        text={messagesLocale[title]}
      />
    </div>
  );
};
